import apollo from '@/apollo.js'
import gql from 'graphql-tag'
import Helpers from '../helpers'
import { findBucket } from './buckets'

export const createBucketDisplayFields = async (bucket) => {
  const responses = []
  for (const displayField of bucket.displayFields) {
    if (("id" in displayField) === false) {
      const response = await apollo.mutate(
        {
          mutation: gql(`
            mutation createBucketDisplayField($bucketId: Int!, $fieldSet: String!, $fieldName: String!, $position: Int!) {
              createBucketDisplayField(bucketId: $bucketId, fieldSet: $fieldSet, fieldName: $fieldName, position: $position) {
                bucketDisplayField { id fieldset fieldName position } error message
              }
            }
          `),
          variables: { bucketId: bucket.id, fieldSet: displayField.fieldset, fieldName: displayField.fieldName, position: displayField.position }
        }
      )
      responses.push(response)
    }
  }
  return responses
}

export const updateBucketDisplayFields = async (bucket) => {
  const oldBucket = await findBucket(bucket.id)

  if (Helpers.isPresent(oldBucket.displayFields) && Helpers.isPresent(bucket.displayFields)) {
    const existingDisplayFieldIds = oldBucket.displayFields.map(field => field.id)
    const updatedDisplayFieldIds = bucket.displayFields.map(field => field.id)

    for (const displayFieldId of existingDisplayFieldIds) {
      if (updatedDisplayFieldIds.includes(displayFieldId) === false) {
        apollo.mutate(
          {
            mutation: gql(`
              mutation deleteBucketDisplayField($id: Int!) {
                deleteBucketDisplayField(id: $id) { error message}
              }
            `),
            variables: { id: displayFieldId }
          }
        )
      }
    }
  }

  bucket.displayFields.forEach(function (displayField) {
    if ("id" in displayField) {
      const response = apollo.mutate(
        {
          mutation: gql(`
            mutation updateBucketDisplayField($id: Int!, $fieldSet: String!, $fieldName: String!, $position: Int!) {
              updateBucketDisplayField(id: $id, fieldSet: $fieldSet, fieldName: $fieldName, position: $position) {
                bucketDisplayField { id fieldset fieldName position } error message
              }
            }
          `),
          variables: { id: displayField.id, fieldSet: displayField.fieldset, fieldName: displayField.fieldName, position: displayField.position }
        }
      )
      return response.each
    }
  })
}

export const createBucketSortFields = async (bucket) => {
  const responses = []
  bucket.sortFields.forEach(function (sortField) {
    if (sortField.position > 0) {
      const response = apollo.mutate(
        {
          mutation: gql(`
            mutation createBucketSortField($bucketId: Int!, $fieldSet: String!, $fieldName: String!, $position: Int!, $direction: String!) {
              createBucketSortField(bucketId: $bucketId, fieldSet: $fieldSet, fieldName: $fieldName, position: $position, direction: $direction) {
                bucketSortField { id fieldset fieldName position direction } error message
              }
            }
          `),
          variables: {
            bucketId: bucket.id,
            fieldSet: sortField.fieldset,
            fieldName: sortField.fieldName,
            position: sortField.position,
            direction: sortField.direction
          }
        }
      )
      responses.push(response)
    }
  })
  return Promise.all(responses)
}

export const deleteBucketSortFields = async (bucket) => {
  const oldBucket = await findBucket(bucket.id)

  if (Helpers.isPresent(oldBucket.sortFields)) {
    const existingSortFieldIds = oldBucket.sortFields.map(field => field.id)

    existingSortFieldIds.forEach(function (sortFieldId) {
      apollo.mutate(
        {
          mutation: gql(`
            mutation deleteBucketSortField($id: Int!) {
              deleteBucketSortField(id: $id) { error message }
            }
          `),
          variables: { id: sortFieldId }
        }
      )
    })
  }
}

export const createBucketFilterFields = async (bucket) => {
  const responses = []
  bucket.criteria.forEach(function (criteriaField) {
    if (("id" in criteriaField) === false) {
      const response = apollo.mutate(
        {
          mutation: gql(`
            mutation createBucketCriteria($bucketId: Int!, $fieldSet: String!, $fieldName: String!, $condition: String!, $value: String) {
              createBucketCriteria(bucketId: $bucketId, fieldSet: $fieldSet, fieldName: $fieldName, condition: $condition, value: $value) {
                bucketCriteria { id fieldset fieldName condition value } error message
              }
            }
          `),
          variables: { bucketId: bucket.id, fieldSet: criteriaField.fieldset, fieldName: criteriaField.fieldName, condition: criteriaField.condition, value: criteriaField.value }
        }
      )
      responses.push(response)
    }
  })
  return responses.each
}

export const updateBucketFilterFields = async (bucket) => {
  const oldBucket = await findBucket(bucket.id)

  if (Helpers.isPresent(oldBucket.criteria) && Helpers.isPresent(bucket.criteria)) {
    const existingCriteriaIds = oldBucket.criteria.map(field => field.id)
    const updatedCriteriaIds = bucket.criteria.map(field => field.id)

    existingCriteriaIds.forEach(function (criteriaId) {
      if (updatedCriteriaIds.includes(criteriaId) === false) {
        apollo.mutate(
          {
            mutation: gql(`
              mutation deleteBucketCriteria($id: Int!) {
                deleteBucketCriteria(id: $id) { error message }
              }
            `),
            variables: { id: criteriaId }
          }
        )
      }
    })
  }

  bucket.criteria.forEach(function (criteriaField) {
    if ("id" in criteriaField) {
      const response = apollo.mutate(
        {
          mutation: gql(`
            mutation updateBucketCriteria($id: Int!, $fieldSet: String!, $fieldName: String!, $condition: String!, $value: String) {
              updateBucketCriteria(id: $id, fieldSet: $fieldSet, fieldName: $fieldName, condition: $condition, value: $value) {
                bucketCriteria { id fieldset fieldName condition value } error message
              }
            }
          `),
          variables: { id: criteriaField.id, fieldSet: criteriaField.fieldset, fieldName: criteriaField.fieldName, condition: criteriaField.condition, value: criteriaField.value }
        }
      )
      return response.each
    }
  })
}
